import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {+, - 등을 표기하는 동그라미 버튼}
 */

interface IProps {
  children: string;
  name?: string;
  id?: string | undefined;
  onClick?: (e: any) => void;
  value?: string | number;
  disabled?: boolean;
  style?: React.CSSProperties;
}
const CircleButton: React.FC<IProps> = ({
  children,
  name,
  id,
  onClick,
  value,
  disabled,
  style,
}) => {
  return (
    <StyledButton
      name={name}
      id={id}
      onClick={onClick}
      value={value}
      disabled={disabled}
      style={style}
    >
      {children}
    </StyledButton>
  );
};

export default CircleButton;

const StyledButton = styled.button`
  height: 1.8rem;
  width: 1.8rem;
  border-radius: 50%;
  margin-left: 0.3rem;
  color: ${(props) =>
    props.disabled ? props.theme.colors.gray_3 : theme.colors.black};
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.gray_4
      : props.theme.colors.table_button};
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
  /* font-size: 1.2rem; */
  &:hover {
    background-color: white;
    box-shadow: 2px 2px 7px 0.2px rgb(0 0 0 / 20%);
  }
`;
